function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0407 26C12.7649 26.0006 12.4917 25.9468 12.2368 25.8419C11.9819 25.7369 11.7503 25.5828 11.5553 25.3884L2.64248 16.5013C2.44168 16.3082 2.28145 16.0772 2.17116 15.8217C2.06086 15.5662 2.00271 15.2914 2.00009 15.0133C1.99747 14.7352 2.05044 14.4594 2.1559 14.2019C2.26136 13.9444 2.41721 13.7105 2.61434 13.5137C2.81148 13.3169 3.04595 13.1612 3.30409 13.0557C3.56223 12.9502 3.83886 12.897 4.11783 12.8992C4.39681 12.9014 4.67256 12.959 4.92897 13.0686C5.18539 13.1782 5.41735 13.3376 5.61131 13.5375L13.0386 20.9417L26.412 7.61412C26.806 7.2211 27.3404 7.0002 27.8978 7C28.4551 6.9998 28.9897 7.22033 29.384 7.61308C29.7782 8.00582 29.9998 8.5386 30 9.09422C30.0002 9.64984 29.779 10.1828 29.385 10.5758L14.5262 25.3884C14.3312 25.5828 14.0995 25.7369 13.8446 25.8419C13.5897 25.9468 13.3165 26.0006 13.0407 26Z"
});

function SvgIcCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompleted);
export default ForwardRef;